<template>
  <div class="score">
    <div v-if="value < 0">
      <div>
         <div class="tooltip-container">
            <span class="score-label">NA</span>
            <div class="tooltip tooltip-top" role="tooltip">
              <div class="tooltip-outer">
                <div class="tooltip-arrow"></div>
                <div v-if="label == 'trip.driving_behavior.focus'" class="tooltip-inner">{{ $t(tooltip) }}</div>
                <div v-else class="tooltip-inner"> {{ $t(tooltip) }}</div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div v-else class="gauge-wrapper">
      <simple-gauge :score="value" />
      <div class="amount">
        <span>{{ Math.round(value) }}</span>
        <span class="percentage">%</span>
      </div>
    </div>
    <div class="text">{{ $t(label) }}</div>
  </div>
</template>

<script>
import SimpleGauge from 'charts/SimpleGauge';

export default {
  components: {
    SimpleGauge
  },

  props: {
    label: {
      type: String,
      required: true
    },

    tooltip: {
      type: String,
      required: true
    },

    value: {
      type: Number,
      required: true
    },
  },

}
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.gauge-wrapper {
  position: relative;
}

.score {
  text-align: center;
}

.tooltip-container > .score-label {
  line-height: 3.2rem;
}

.amount,
.text {
  text-align: center;
  color: rgba($black, .87);
}

.amount {
  position: absolute;
  display: flex;
  align-items: baseline;
  top: 22px;
  left: 50%;
  transform: translateX(-50%);
  font-size: $size-medium;
  line-height: .8;

  .percentage {
    font-size: $size-small;
  }
}

.text {
  font-size: .875rem;
  line-height: 1.29;
}
</style>
